import { render, staticRenderFns } from "./CollapsibleTreeWithSites.vue?vue&type=template&id=4c478e36&scoped=true"
import script from "./CollapsibleTreeWithSites.vue?vue&type=script&lang=js"
export * from "./CollapsibleTreeWithSites.vue?vue&type=script&lang=js"
import style0 from "./CollapsibleTreeWithSites.vue?vue&type=style&index=0&id=4c478e36&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c478e36",
  null
  
)

export default component.exports